import { MediaStorageType, FTPConnectionResponse, FTPClientConnectionInfoDTO, FTPClientType } from './../../../../../base/models/models.swagger.generated';
import { EnumTranslationService } from './../../../../../base/services/enum-translation.service';
import { DropDownConstantsFactory } from './../../../../../base/shared/syncfusion/dropdown-constants-factory';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ImportConfigurationFtpFormType } from './configuration-form-ftp-form-type';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { Component, ChangeDetectorRef, AfterViewChecked, OnInit, ViewChild } from '@angular/core';
import { Uploader, FileInfo, SelectedEventArgs, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { MimeTypeHelper } from 'src/app/base/shared/mime-type.helper';
import { TranslateModule } from '@ngx-translate/core';

import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { ConfigurationFormFtpService } from './configuration-form-ftp.service';

@Component({
    selector: 'app-configuration-form-ftp',
    templateUrl: './configuration-form-ftp.component.html',
    styleUrls: ['./configuration-form-ftp.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, DropDownListModule, YesNoGroupButtonComponent, UploaderModule, DialogModule, TranslateModule]
})
export class ConfigurationFormFtpComponent implements OnInit, AfterViewChecked {
  @ViewChild('defaultupload') public defaultupload: Uploader;
  @ViewChild('dialog') public dialog: DialogComponent;

  public get configurationFormFtp(): FormGroup<ImportConfigurationFtpFormType> {
    return this.formsCoordinationService.configurationFormFtp;
  }

  public isTestingConnection = false;
  public ftpConnectionResponse: FTPConnectionResponse;
  public formattedLog = '';

  public enumDropdownSettings = DropDownConstantsFactory.createNumericEnumDropdownSettings();
  public ftpTypes = this.enumTranslateService.translateNumericEnum(FTPClientType, 'i18n.domain.import-configuration.enums.ftp-client-type.');

  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
    private configurationFormFtpService: ConfigurationFormFtpService,
    private enumTranslateService: EnumTranslationService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.configurationFormFtp.controls.useCertificate.valueChanges.subscribe((value) => {
      if (!value) {
        this.onFileRemove();
      }
      this.formsCoordinationService.setValidatorsForFtpConfigForm();
    });

    this.configurationFormFtp.controls.ftpClientType.valueChanges.subscribe(() => {
      switch (this.configurationFormFtp.controls.ftpClientType.value) {
        case FTPClientType.Ftp:
          this.configurationFormFtp.controls.port.setValue(21);
          break;
        case FTPClientType.Sftp:
          this.configurationFormFtp.controls.port.setValue(22);
          break;
        default:
          this.configurationFormFtp.controls.port.setValue(443);
          break;
      }
    });
  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  public showLog(): void {
    this.dialog.show();
  }

  public closeLog(): void {
    this.dialog.hide();
  }

  public testFtpAccess() {
    this.isTestingConnection = true;
    const formValue =  this.configurationFormFtp.getRawValue();
    const connectionInfo = new FTPClientConnectionInfoDTO({
      uRL: formValue.url,
      port: formValue.port,
      fileTransferMode: formValue.ftpClientType,
      userName: formValue.userName,
      password: formValue.password,
      relativePathOfFiles: formValue.relativePath,
      useCertificate: formValue.useCertificate,
      certificateMediaId: formValue.certificateMediaId,
      certificatePassword: formValue.certificatePassword,
      certificateContentBase64: formValue.certificateContentBase64
    });
    this.configurationFormFtpService.testFtpAccess(connectionInfo).subscribe(data => {
      this.ftpConnectionResponse = data;
      this.isTestingConnection = false;
      this.formattedLog = data.connectionLog;
    });
  }

  public handleFileInput($event: SelectedEventArgs) {
    const files: FileInfo[] = $event.filesData;
    if (!files || files.length < 1) {
      return;
    }
    const file = files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      let base64Data = event.target.result as string;
      const startIndex = base64Data.search(';base64,');
      if (startIndex > 0) {
        // replace type by cert
        base64Data = 'data:' + MimeTypeHelper.getMimeType(file.type.toLowerCase()) + base64Data.substring(startIndex);
      } else {
        base64Data = 'data:' + MimeTypeHelper.getMimeType(file.type.toLowerCase()) + ';base64,' + base64Data;
      }
      this.configurationFormFtp.controls.certificateContentBase64.setValue(base64Data);
    };
    reader.readAsDataURL(file.rawFile as File);
    this.configurationFormFtp.controls.certificateMediaName.setValue(file.name);
    const mediaType = this.mapFileTypeToMediaType(file.type);
    this.configurationFormFtp.controls.certificateMediaType.setValue(mediaType);
    this.configurationFormFtp.controls.certificateMediaId.setValue(null);
  }

  public onFileRemove() {
    this.defaultupload?.refresh(); // get rid of added input fields
    this.configurationFormFtp.controls.certificateMediaId.setValue(null);
    this.configurationFormFtp.controls.certificateMediaName.setValue(null);
    this.configurationFormFtp.controls.certificateContentBase64.setValue(null);
    this.configurationFormFtp.controls.certificateMediaType.setValue(null);
    this.configurationFormFtp.controls.certificatePassword.setValue(null);
    this.defaultupload?.clearAll();
  }

  private mapFileTypeToMediaType(fileType: string): MediaStorageType {
    if (!fileType) {
      return null;
    }
    const type = fileType.toLowerCase();
    for (const enumMember in MediaStorageType) {
      if (typeof(enumMember) === 'string' && enumMember.toLowerCase() === type) {
        return MediaStorageType[enumMember as string];
      }
    }
    return null;
  }

}
